<template>
  <div class="row">
    <div class="col-6 text-left">
      <h5 :class="`link ${hover ? '' : 'text-primary'}`" v-on:click="visualizar()">
        {{ formatProtocolo(numeroProcesso) }}
      </h5>
      Autor: <strong>{{ autor }}</strong>
      <br>
      Tipo Documental: <strong>{{ especie }}</strong>
      <br>
      Assunto: <strong>{{ assunto }}</strong>
      <br>
      Data Criação: <strong>{{ dataCriacao }}</strong>
    </div>
    <div v-if="disableInfo(hover)" class="col-4 text-left">
      <br>
      Tipo: <strong>{{ tipoProtocolo }}</strong>
      <br>
      Orgão: <strong>{{ siglaOrgao }}</strong>
      <br>
      Interessado: <strong>{{ ultimoInteressado.nome }}</strong>
      <br>
      {{ultimoInteressado.tipoIdentificador}}: <strong>{{  formatIdentificador(ultimoInteressado.identificador, ultimoInteressado.tipoIdentificador) }}</strong>
    </div>
    <div v-if="hover" :class="hover ? 'col-6 text-right' : 'col-2 text-right'">
      <span class="link">
        <i
          v-tooltip.auto-start="`Visualizar Processo ${numeroProcesso}`"
          class="fa fa-search fa-1-5x text-white m-1 link"
          aria-hidden="true"
          v-on:click="visualizar()"
        ></i>
      </span>
    </div>
    <div v-if="disableInfo(hover)" class="col-1 text-left"></div>
  </div>
</template>

<script>
import lodash from 'lodash'

import { protocoloParse } from '@/uteis/converters/ProtocoloConverter'
import { localDateParse } from '@/uteis/converters/LocalDateConverter'
import { identificadorParse } from '@/uteis/converters/IdentificadorConverter'

export default {
  props: {
    data: { required: true, type: Object },
    hover: { required: true, type: Boolean }
  },

  methods: {
    disableInfo (hover) {
      if (hover) {
        this.departamentoCriacao = ''
        this.orgaoCriacao = ''
        this.siglaOrgao = ''
        this.ultimoInteressado = ''
      } else {
        this.debouncedGetData()
      }
      return !hover
    },

    updateFields () {
      this.departamentoCriacao = this.data.atributos.descricaoDepartamento
      this.orgaoCriacao = this.data.atributos.descricaoOrgao
      this.siglaOrgao = this.data.atributos.siglaOrgao
      this.ultimoInteressado = this.data.atributos.interessados[this.data.atributos.interessados.length - 1]
    },

    visualizar () {
      this.$router.push({
        name: 'visualizadorProcesso',
        query: {
          numeroProcesso: this.data.atributos.numeroProcesso.replace(/\//g, ''),
          disableMenuProcesso: true,
          buscaGeral: true
        }
      })
    },

    formatData (date) {
      return localDateParse(date).value
    },

    formatProtocolo (protocolo) {
      return protocoloParse(protocolo).value
    },

    formatIdentificador (identificador, tipoidentificador) {
      return identificadorParse(identificador, tipoidentificador).value
    }
  },

  data () {
    return {
      id: '',
      numeroProcesso: '',
      assunto: '',
      dataCriacao: '',
      tipoProtocolo: '',
      autor: '',
      departamentoCriacao: '',
      orgaoCriacao: '',
      siglaOrgao: '',
      especie: '',
      ultimoInteressado: ''

    }
  },

  created () {
    this.id = this.data.id
    this.numeroProcesso = this.data.atributos.numeroProcesso
    this.assunto = this.data.atributos.assunto
    this.especie = this.data.atributos.especie
    this.dataCriacao = this.data.atributos.dataCriacaoFormatada
    this.tipoProtocolo = this.data.atributos.tipoProtocolo
    this.autor = this.data.atributos.autor

    this.departamentoCriacao = this.data.atributos.descricaoDepartamento
    this.orgaoCriacao = this.data.atributos.descricaoOrgao
    this.siglaOrgao = this.data.atributos.siglaOrgao

    this.ultimoInteressado = this.data.atributos.interessados[this.data.atributos.interessados.length - 1]

    this.debouncedGetData = lodash.debounce(this.updateFields, 100)
  }
}
</script>
